import {ILinkCategory} from "@/types/models/ILinkCategory.ts";
import {useForm} from "@mantine/form";
import OmniFetchTS from "@/util/OmniFetchTS.tsx";
import {modals} from "@mantine/modals";
import {Button, Group, Stack, TextInput} from "@mantine/core";
import TablerIconPicker from "@/components/icon_picker/TablerIconPicker.tsx";
import {EDIT_LINK_CATEGORY_MODAL_ID} from "@/components/SidebarLinks/EditLinkCategoryModal/modal_utils.tsx";

export interface LinkCategoryModalProps {
    category: ILinkCategory
    onComplete: () => void
}

export default function EditLinkCategoryModal({category, onComplete}: LinkCategoryModalProps) {
    interface LinkCategoryForm {
        id: string
        name: string
        icon: string | undefined | null
    }
    const form = useForm<LinkCategoryForm>({
        initialValues: {
            id: category ? category.id.toString() : "",
            name: category ? category.name : "",
            icon: category ? category.icon : "question",
        },
        validate: {
            name: (v) => v.length <= 72 ? null : "The Category name must be less than 72 characters",
            icon: (v) => v ? null : "Must select a Category icon"
        }
    })
    return <form onSubmit={form.onSubmit((values) => {
        OmniFetchTS(`/api/v1/links/categories/${values.id}`, {method: "POST"}, values).then((json) => {
            if (json.success) {
                modals.close(EDIT_LINK_CATEGORY_MODAL_ID)
                onComplete()
            }
        })
    })}>
        <Stack>
            <TextInput
                label={"Name"} required
                description={"The name of this Category"}
                {...form.getInputProps("name")}
            />
            <TablerIconPicker label={"Icon"} required {...form.getInputProps("icon")}/>
            <Group justify={"end"}>
                <Button variant="default" onClick={() => modals.close(EDIT_LINK_CATEGORY_MODAL_ID)}>Cancel</Button>
                <Button type={"submit"}>Edit Category</Button>
            </Group>
        </Stack>
    </form>
}